"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_2 = require("@headlessui/react");
const react_3 = require("react");
const DialogProvider_1 = require("./DialogProvider");
const constants_1 = require("../../constants");
const utils_1 = require("../../utils");
const Icon_1 = require("../Icon");
const Backdrop = styled_1.default.div `
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
`;
const Content = styled_1.default.div `
  position: fixed;
  inset: 0;
  display: grid;
  align-items: center;
  justify-items: center;
  padding: 1rem;
  overflow: auto;
`;
const DialogComponent = ({ isOpen, onClose, initialFocus, children, }) => {
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: ({ css }) => ((0, jsx_runtime_1.jsx)(react_2.Transition, { show: isOpen, as: react_3.Fragment, children: (0, jsx_runtime_1.jsxs)(react_2.Dialog, { onClose: onClose, className: css `
              position: relative;
              z-index: ${constants_1.theme.zIndex.popover};
            `, initialFocus: initialFocus, children: [(0, jsx_runtime_1.jsx)(react_2.Transition.Child, { as: react_3.Fragment, enter: css `
                transition: opacity ${constants_1.theme.animation.transition};
              `, enterFrom: css `
                opacity: 0;
              `, enterTo: css `
                opacity: 100%;
              `, leave: css `
                transition: opacity ${constants_1.theme.animation.transition};
              `, leaveFrom: css `
                opacity: 100%;
              `, leaveTo: css `
                opacity: 0;
              `, children: (0, jsx_runtime_1.jsx)(Backdrop, {}) }), (0, jsx_runtime_1.jsx)(react_2.Transition.Child, { as: react_3.Fragment, enter: css `
                transition:
                  opacity ${constants_1.theme.animation.transition},
                  transform ${constants_1.theme.animation.transition};
              `, enterFrom: css `
                opacity: 0;
                transform: scale(0.95);
              `, enterTo: css `
                opacity: 100%;
                transform: scale(1);
              `, leave: css `
                transition:
                  opacity ${constants_1.theme.animation.transition},
                  transform ${constants_1.theme.animation.transition};
              `, leaveFrom: css `
                opacity: 100%;
                transform: scale(1);
              `, leaveTo: css `
                opacity: 0;
                transform: scale(0.95);
              `, children: (0, jsx_runtime_1.jsx)(Content, { children: (0, jsx_runtime_1.jsx)(DialogProvider_1.DialogProvider, { isOpen: isOpen, onClose: onClose, children: children }) }) })] }) })) }));
};
const Panel = (0, styled_1.default)(react_2.Dialog.Panel)((props) => (0, utils_1.createStyles)(props.styles));
const Title = (0, styled_1.default)(react_2.Dialog.Title)((props) => (0, utils_1.createStyles)(props.styles));
const Description = (0, styled_1.default)(react_2.Dialog.Description)((props) => (0, utils_1.createStyles)(props.styles));
const CloseButtonElement = styled_1.default.button `
  background: transparent;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  padding: 0;
  color: ${constants_1.Color.DARK_GREY};

  :hover {
    color: ${constants_1.Color.DARKER_GREY};
  }

  :active {
    color: ${constants_1.Color.CHARCOAL};
  }
`;
const Close = function Close({ className, onClick, ...iconProps }) {
    const { onClose } = (0, DialogProvider_1.useDialogContext)();
    return ((0, jsx_runtime_1.jsx)(CloseButtonElement, { type: "button", className: className, onClick: onClick || onClose, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "XIcon", size: "lg", ...iconProps }) }));
};
exports.Dialog = Object.assign(DialogComponent, {
    Panel,
    Title,
    Description,
    Close,
});
